import React, { useState, useEffect, useCallback } from 'react';
import Autocomplete from '@material-ui/lab/Autocomplete';
import TextField from '@material-ui/core/TextField';
import CircularProgress from '@material-ui/core/CircularProgress';
const AutocompleteSelectOptions = ({
  id = 'autocomplete-standard',
  size = 'small',
  options = [],
  label = '',
  placeholder = '',
  value,
  onChange,
  fieldOptions = { id: 'id', title: 'title' },
  ...another
}) => {
  const [loading, setLoading] = useState(false);
  const [selectValue, setSelectValue] = React.useState(value || null);

  useEffect(() => {
    setSelectValue(value);
  }, [value]);

  // Autocomplete  https://material-ui.com/components/autocomplete/#autocomplete (Controllable states)
  const handleChange = async (e, newValue) => {
    setSelectValue(newValue);
    if (onChange) {
      !loading && setLoading(true);
      await onChange(e, newValue);
      setLoading(false);
    }
  };
  return (
    <div>
      <Autocomplete
        id={id}
        size={size}
        fullWidth
        options={options}
        value={selectValue}
        // getOptionSelected={(option, value) =>
        //   option[fieldOptions.id] === value[fieldOptions.id]
        // }
        getOptionLabel={(option) => option[fieldOptions.title]}
        onChange={handleChange}
        renderInput={(params) => (
          <TextField
            {...params}
            variant="outlined"
            label={label}
            placeholder={placeholder}
            InputProps={{
              ...params.InputProps,
              startAdornment: (
                <React.Fragment>
                  {loading ? (
                    <CircularProgress color="inherit" size={20} />
                  ) : null}
                  {params.InputProps.startAdornment}
                </React.Fragment>
              ),
            }}
          />
        )}
        disabled={loading}
        {...another}
      />
    </div>
  );
};

export default AutocompleteSelectOptions;
